export const environment = {
  production: true,
  baseUrl: 'https://www.tropeando.com.py/api',
  websocketUrl: 'wss://www.tropeando.com.py/ws'
};
